import axiosHttp from "services/axiosHttp";
import { MEAL_BASE_URL } from "configs/AppConfig";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//ACTION
export const fetchMealConsumptionLog = createAsyncThunk("fetchMealConsumptionLog", async ({ page, limit, filters }, { rejectWithValue }) => {
	//FORMATE DATE RANGE
	const formatDate = (date) => (date && date.isValid() ? date.format("YYYY-MM-DD") : "");

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		scheduleId: filters?.scheduleId ?? "",
		scheduleType: filters?.scheduleType ?? "",
		location: filters?.location_id ?? "",
		keyword: filters?.keyword?.trim() ?? "",
		startDate: formatDate(filters?.startDate),
		endDate: formatDate(filters?.endDate),
	});

	try {
		const response = await axiosHttp.get(`${MEAL_BASE_URL}consumption-logs?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const MealConsumptionLoggerSlice = createSlice({
	name: "MealConsumptionLoggerSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMealConsumptionLog.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMealConsumptionLog.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});

		builder.addCase(fetchMealConsumptionLog.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default MealConsumptionLoggerSlice.reducer;
